import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Tabs({ tabs, activeKey, onChange, variant = "underline" }) {
    if (variant === "pills") {
        return (_jsx("div", { style: {
                display: "inline-flex",
                background: "var(--surface)",
                border: "1px solid var(--border)",
                borderRadius: 999,
                padding: 4,
                gap: 4,
            }, children: tabs.map((t) => {
                const active = t.key === activeKey;
                return (_jsxs("button", { type: "button", onClick: () => onChange(t.key), style: {
                        padding: "8px 16px",
                        borderRadius: 999,
                        fontWeight: 600,
                        fontSize: 13,
                        color: active ? "var(--navy-900)" : "var(--text-muted)",
                        background: active ? "linear-gradient(135deg, var(--gold-500), var(--gold-400))" : "transparent",
                        border: "none",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                    }, children: [t.label, t.badge ? _jsx("span", { style: { marginLeft: 8, opacity: 0.7 }, children: t.badge }) : null] }, t.key));
            }) }));
    }
    return (_jsx("div", { role: "tablist", style: {
            display: "flex",
            gap: 4,
            borderBottom: "1px solid var(--border)",
            overflowX: "auto",
        }, children: tabs.map((t) => {
            const active = t.key === activeKey;
            return (_jsxs("button", { type: "button", role: "tab", "aria-selected": active, onClick: () => onChange(t.key), style: {
                    padding: "12px 18px",
                    fontWeight: active ? 700 : 500,
                    fontSize: 13,
                    color: active ? "var(--accent)" : "var(--text-muted)",
                    background: "transparent",
                    border: "none",
                    borderBottom: active ? "2px solid var(--accent)" : "2px solid transparent",
                    marginBottom: -1,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    letterSpacing: "0.02em",
                    textTransform: "uppercase",
                }, children: [t.label, t.badge ? _jsx("span", { style: { marginLeft: 6 }, children: t.badge }) : null] }, t.key));
        }) }));
}
//# sourceMappingURL=Tabs.js.map